import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'redux-store/store'
import { userInterface } from 'redux-store/userInterface/userInterface.actions'
import { useLocation } from 'react-router-dom'

export const useTryOpenViewStream = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const id = useSelector(
    (state: RootState) => state.stream?.data?.mediaObject?.id
  )

  //I kept it for a test reason here /will be removed after optimization
  // const type = useSelector(
  //   (state: RootState) => state.stream?.data?.mediaObject?.type
  // )

  const type = useMemo(() => {
    if (location.pathname.includes('/games/g/')) return 'livestream'
    return 'video'
  }, [location.pathname])

  return useCallback(async () => {
    if (!id || !type) return
    // 'Stream is offline' gate disabled: always open the stream instead of
    // checking getWatchableStatus() and blocking with StreamOfflineView.
    // To re-enable, restore the getWatchableStatus() check:
    //   const result = await getWatchableStatus(id, type)
    //   if (result.status === 'online') { clearStreamOffline(); openViewStream() }
    //   else { setStreamOffline(result.message) }
    // (also re-add the `getWatchableStatus` import).
    dispatch(userInterface.clearStreamOffline())
    dispatch(userInterface.openViewStream())
  }, [id, type, dispatch])
}
